<app-spinner-overlay></app-spinner-overlay>
<div class="contenitore">
  <div class="titolo-pagina">
    <app-titolo-subtitolo
      titolo="Azioni e Buone Pratiche"
      subTitolo="Iniziative che le aziende possono intraprendere per ridurre il proprio impatto ambientale"
    ></app-titolo-subtitolo>
  </div>
  <app-lista-tabellare
    #tabella
    [fnCaricamentoDati]="fnCaricamentoDati"
    [colonne]="colonne"
    [maxNrButton]="1"
    [filtri]="filtri"
    (bottoniListaClick)="bottoniListaClick($event)"
  >
    @if (this.utenteService.isPermessoAttivo('CREATE_CONFIGURAZIONI')) {
      <div btnEnd style="display: flex; justify-content: center; column-gap: 20px">
        <button
          mat-flat-button
          class="primary-button"
          color="primary"
          (click)="creaNuovoAzioneBP()"
        >
          Nuovo
        </button>
        <div class="cnt-imp-exp-btn">
          <button
            mat-flat-button
            color="accent"
            class="accent-button btn-import"
            (click)="importaAzioniBP()"
          >
            Importa
            <mat-icon> file_upload </mat-icon>
          </button>
          <button
            mat-flat-button
            color="accent"
            class="accent-button btn-export"
            (click)="exportAzioni()"
          >
            Esporta
            <mat-icon> file_download </mat-icon>
          </button>
        </div>
      </div>
    }
  </app-lista-tabellare>
</div>
